import React from 'react'

const WithholdingsListContext = React.createContext({
  withholdings: [],
  isLoading: false
})

export default WithholdingsListContext
